import LoginForm from '@/form/auth/LoginForm.tsx';

const LoginPage = () => {
  return (
    <div>
      <LoginForm />
    </div>
  );
};

export default LoginPage;
